/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

function useTemplate(templateId) {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'templates' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    ...rest
  } = useQuery(
    [namespace, templateId],
    () =>
      okapiKy
        .get(
          templateId
            ? `inventory-templates/${templateId}`
            : 'inventory-templates?limit=2147483647',
        )
        .json(),
    { enabled: templateId ? Boolean(templateId) : true },
  );

  const defaultTemplate = data?.templates?.find(
    (template) => template.isDefault === true,
  );

  return {
    isLoading,
    isError,
    templates: templateId ? data : data.templates,
    defaultTemplate,
    currentTemplate: templateId && data ? data : defaultTemplate,
    refetch,
    rest,
  };
}

export default useTemplate;
